module.exports = __webpack_public_path__ + "static/media/utensils-alt.67d24a87.svg";